import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';

import { PAYMENT_TERMINAL_MANUAL } from './ui-paytef-utils';
import { PaymentTerminal } from '@app/modules/model/payment-terminal';

import { languageSupport, languageService } from '@app/modules/common/language';
import { viewService } from '@app/modules/view';

/**
 * Full-modal picker for payment terminals. Visually mirrors
 * UiToPrintertModal (header + scrollable list of devices with icon,
 * name, host:port) so the cashier gets the same layout they already
 * know from the print picker. Used when more than one paytef terminal
 * is configured in the place.
 */
@Component({
    selector: 'modal-pickterminal',
    templateUrl: './ui-pickterminal-modal.html',
    styleUrls: [
        './ui-pickterminal-modal.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiPickTerminalModal extends languageSupport implements OnInit, OnDestroy {

    public _terminals: Array<PaymentTerminal> = [];

    get Terminals(){
        return this._terminals;
    }

    TerminalTill(_terminal){
        return _terminal.rasppi?.name || null;
    }

    get MultiplePOS(){
        // Only annotate the till name in the item when there are more
        // than one POS services in the place. Matches UiToPrintertModal.
        let _services = new Set<any>();
        for (let _t of this._terminals){
            if (_t.rasppi){
                _services.add(_t.rasppi);
            }
        }
        return _services.size > 1;
    }

    constructor(
        lang: languageService,
        private change: ChangeDetectorRef,
        private modalCtrl: ModalController,
        private params: NavParams,
        public view: viewService
    ) {
        super(lang, change);
    }

    ngOnInit(){
        this._terminals = this.params.get('terminals') || [];
    }

    ngOnDestroy(){
        super.OnDestroy();
    }

    ToTerminal(_terminal){
        this.modalCtrl.dismiss(_terminal);
    }

    OnManual(){
        this.modalCtrl.dismiss(PAYMENT_TERMINAL_MANUAL);
    }

    OnClose(){
        this.modalCtrl.dismiss(null);
    }
}
